import { RouteProps, Navigate, Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { isLoggedInState } from '../../atoms/user';

type Props = RouteProps;
export default function ProtectedRoute({ element, ...others }: Props) {
  const isLoggedIn = useRecoilValue(isLoggedInState);

  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
}
